import { ColDef, ICellRendererParams } from "ag-grid-community";
import { generateLiveResourcesPath } from "../../../../../accounts-group/utils/helpers/generateLiveResourcesPath";
import { EmbeddedAccount } from "@/services/cloudchipr.api";
import { AccountInfoData } from "@/components/common/AccountInfoData";

export const resourceAccountColumnDef: ColDef = {
  field: "resource.account",
  headerName: "Account",

  valueGetter: ({ data }) =>
    data?.resource?.account?.provider_account_name ??
    data?.resource?.account?.provider_account_id ??
    "",

  comparator: (valueA, valueB) => {
    return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
  },

  cellRenderer: ({ data }: ICellRendererParams) => {
    const account = data?.resource?.account as EmbeddedAccount;

    if (!account) {
      return null;
    }

    const link = generateLiveResourcesPath({
      provider: account.provider,
      accountIds: account.id,
      resourceType: data?.resource_type,
    });

    const accountName =
      account.provider_account_name ?? account.provider_account_id;

    return (
      <AccountInfoData
        link={link}
        accountName={accountName}
        provider={account.provider}
        nameTypographyProps={{ fontSize: 14 }}
        accessType={account.provider_access_type}
      />
    );
  },
};
